module.exports = __webpack_public_path__ + "img/jbt7941_2-1995_4.prt.192d4f92.jpg";